import React from "react";
import {Avatar, Grid, Typography} from "@mui/material";

type Props = {
    coderNotes: AmplifyAPI.CoderNoteRow[];
    patientMrn?: string;
    accession?: string;
}

export default function CoderNotesRowPopover(props: Props) {
    const formatLocal = (created_date: string) => {
        const fixedDate = created_date.replace("[UTC]", "");
        const date = new Date(fixedDate);
        return date.toDateString() + " " + date.toLocaleTimeString();
    }

    const identifier = props.accession || props.patientMrn;
    const identifierType = props.accession ? "Accession" : "Patient MRN";
    
    return (
        <Grid container gap={"0.5em"} sx={{padding: "1em", maxWidth: "550px"}}>
            <Grid>
                <Typography variant={"h2"}>
                    Notes for {identifierType} #{identifier}
                </Typography>
            </Grid>

            <Grid container flexDirection={"column"} gap={"1em"}
                  sx={{
                      flexWrap: "nowrap",
                      maxHeight: "20em",
                      overflowY: "auto"
                  }}
            >
                {props.coderNotes.map((note, index) => {
                    return (
                        <Grid container flexDirection={"row"} gap={"0.25em"} key={index}>
                            <Avatar
                                sx={{
                                    bgcolor: "#6B8D99",
                                    color: "#FFFFFF"
                                }}
                            >
                                {note.coder_firstname[0].toUpperCase() + note.coder_lastname[0].toUpperCase()}
                            </Avatar>

                            <Grid item container flexDirection={"column"} gap={"0.25em"} paddingLeft={"0.5em"}
                                  sx={{flex: 1}}>
                                <Grid sx={{
                                    backgroundColor: "#F2F8FAFF",
                                    color: "#203D48FF",
                                    padding: "0.5em",
                                    borderRadius: "0.1em"
                                }}>
                                    <Typography>
                                        {note.note_content}
                                    </Typography>
                                </Grid>

                                <Grid container flexDirection={"row"} gap={"0.25em"}
                                      sx={{
                                          color: "#717F96FF"
                                      }}
                                >
                                    <Typography>
                                        {formatLocal(note.created_date)}
                                    </Typography>

                                    |

                                    <Typography>
                                        {note.coder_firstname} {note.coder_lastname}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    );
                })}
            </Grid>
        </Grid>
    );
}